import React, { useContext } from "react";
import DataTable from "react-data-table-component";
import ChevronUpSvg from "../../../Svg/ChevronUpSvg";
import AlertContext from "../../../context/AlertContext";

export default function SQLOutput(Props) {
  const Alert = useContext(AlertContext);

  let tableData = Alert.testDetail?.output || Alert.testDetail?.error;

  const isMultipleOutputs =
    Array.isArray(tableData) &&
    tableData.length > 0 &&
    Array.isArray(tableData[0]);

  const renderTable = (data, index = 0) => {
    const columns =
      data?.length > 0
        ? Object.keys(data[0]).map((key) => ({
            selector: (row) => row[key],
            name: key.charAt(0).toUpperCase() + key.slice(1),
          }))
        : [];

    return (
      <div key={index} className="mb-4">
        <DataTable
          striped
          responsive
          data={data}
          highlightOnHover
          columns={columns}
          noDataComponent="No rows returned."
        />
      </div>
    );
  };

  return (
    <div className="sqlOutputMainContainer">
      <div className="sqlOutputHeader" onClick={Props.toggleOutputWindowHeight}>
        <div className="sqlOutputHeaderTitle">Output</div>
        <ChevronUpSvg />
      </div>

      <div className="sqlOutputTestcasesContainer">
        <div className="sqlOutputTestcasesExpectedOutputValue">
          {isMultipleOutputs
            ? tableData.map((subData, index) => renderTable(subData, index))
            : renderTable(tableData)}
        </div>
      </div>
    </div>
  );
}
